import PageLayout from "./PageLayout";
import {Button} from "../general/input/Button";
import {useDispatch} from "react-redux";
import {getCart} from "../../redux/action/cartActions";
import useSession from "../../newStructure/services/state/session/useSession";


const PageTest = () => {

    const dispatch = useDispatch();
    const { sessionData : session } = useSession();

    const runTest = () => {
        dispatch(getCart({session}));
    }

    return (
        <PageLayout>
            <div style={{minHeight: 600}}>
                <Button
                    style={{
                        height: "300px",
                        width: "70vw",
                        margin: "100px auto",
                        textAlign: "center",
                        display: "flex"
                    }}
                    onClick={runTest}>
                    <p style={{
                        margin: "auto auto",
                        fontSize: "10em"
                    }}>Test</p>
                </Button>
            </div>
        </PageLayout>
    )

}

export default PageTest;
